import type { Capability } from '@taler/api-client'

/**
 * The contract's `Capability` enum has no `CAR_*`/`GARAGE_*` entry. A car event is a
 * financial record like a loan or a contact, so viewing and managing the garage gates on
 * the same capability those do - not a per-feature capability the backend does not grant.
 */
export function canViewGarage(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
